import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { TypedCanActivateFn } from '@/common/models';
import { AppInitializerService } from '@/common/services';

/**
 * Guard para rutas públicas que espera a que las traducciones estén cargadas
 * antes de permitir la navegación, asegurando una experiencia visual consistente.
 * markNavigationResolved() ya no se llama aquí; lo hace AppInitializerService
 * al escuchar el evento NavigationEnd del Router.
 */
export const PublicRouteGuard: TypedCanActivateFn<Observable<boolean>> = (): Observable<boolean> => {
  const appInitializerService = inject(AppInitializerService);

  return appInitializerService.translationsReady$.pipe(
    filter(ready => ready),
    take(1),
    map(() => true),
  );
};

